<template>
  <v-app>
    <v-content>
      <transition name="fade">
        <VueExtendLayouts path="admin/layouts"></VueExtendLayouts>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import VueExtendLayouts from 'vue-extend-layout'
export default {
  name: 'App',
  components: { VueExtendLayouts },
  data() {
    return {
      //
    }
  }
}
</script>
